(()=> {
  // Safety if GSAP belum ter-load
  function ready(fn){ document.readyState!='loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  // Respect prefers-reduced-motion
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGSAP() {
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger,ScrollSmoother);

    // Reset: kill existing triggers (berguna saat section re-render di Theme Editor)
    ScrollTrigger.getAll().forEach(t => t.kill());

    // Default selector (global opt-in): semua elemen yg punya [data-reveal]
    const els = document.querySelectorAll('[data-reveal]');
    els.forEach((el, i) => {
      if (el.__revealed) return; // avoid double-binding
      el.__revealed = true;

      // Tipe animasi via data-reveal="up|down|left|right|fade|scale"
      const type = el.getAttribute('data-reveal') || 'up';
      const delay = parseFloat(el.getAttribute('data-reveal-delay') || 0);
      const dur   = parseFloat(el.getAttribute('data-reveal-dur') || 0.8);
      const once  = (el.getAttribute('data-reveal-once') ?? 'true') !== 'false';
      const distance = el.getAttribute('data-reveal-dist') || '40px';

      let from = { opacity: 0 };
      if (type === 'up') from.y = distance;
      if (type === 'down') from.y = `-${distance}`;
      if (type === 'left') from.x = `-${distance}`;
      if (type === 'right') from.x = distance;
      if (type === 'scale') { from.scale = 0.95; }
      // type 'fade' hanya opacity 0

      const to = { opacity: 1, x: 0, y: 0, scale: 1, ease: 'power3.out', duration: dur, delay };

      if (reduceMotion) {
        // Instantly show for reduced motion users
        gsap.set(el, { opacity: 1, x: 0, y: 0, scale: 1 });
        return;
      }

      gsap.fromTo(el, from, {
        ...to,
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: once ? 'play none none none' : 'play pause resume reset',
          once
        }
      });
    });

    // Stagger group: container yg punya [data-reveal-stagger]
    document.querySelectorAll('[data-reveal-stagger]').forEach(container => {
      if (container.__staggered) return;
      container.__staggered = true;

      const items = container.querySelectorAll('[data-reveal-child]');
      if (!items.length) return;

      const dur = parseFloat(container.getAttribute('data-reveal-dur') || 0.8);
      const stagger = parseFloat(container.getAttribute('data-reveal-stagger') || 0.08);
      const distance = container.getAttribute('data-reveal-dist') || '30px';

      if (reduceMotion) { gsap.set(items, { opacity:1, y:0 }); return; }

      gsap.from(items, {
        opacity: 0,
        y: distance,
        duration: dur,
        ease: 'power3.out',
        stagger,
        scrollTrigger: { trigger: container, start: 'top 85%', once: true }
      });
    });
  }

  // Re-init saat section di-load/di-select di Theme Editor (Thinker pakai Section Rendering API)
  ['shopify:section:load','shopify:section:unload','shopify:section:select','shopify:section:deselect','shopify:block:select','shopify:block:deselect']
    .forEach(evt => document.addEventListener(evt, () => setTimeout(initGSAP, 10)));

  ready(() => setTimeout(initGSAP, 0));
})();
